import initData from 'init-data';

import ads from './ads/initial-state';
import categories from './categories/initial-state';
import environment from './environment/initial-state';
import items from './items/initial-state';
import member from './member/initial-state';
import multiCurrency from './multi-currency/initial-state';
import language from './language/initial-state';
import page from './page/initial-state';
import search from 'tradera-state/discover/initial-state';
import ui from './ui/initial-state';
import views from './views/initial-state';

const state = getInitialState(
    {
        ads,
        categories,
        environment,
        initData,
        items,
        member,
        multiCurrency,
        language,
        page,
        search,
        ui,
        views
    },
    initData
);

/**
 * Builds a complete initial state tree from a map of slice initial states, provided as a state object or a function that builds state from arguments
 *
 * @param {object} initializers
 * @param {string} initializers.key
 * @param {function|object} initializers.initialize
 * @param args
 * @return {object}
 */
function getInitialState(initializers, ...args) {
    const state = {};
    Object.entries(initializers).forEach(([key, initialize]) => {
        state[key] =
            typeof initialize === 'function' ? initialize(...args) : initialize;
    });
    return state;
}

export default state;
